// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RefrigeratedFreightRouteImport } from './routes/refrigerated-freight'
import { Route as DryVanFreightRouteImport } from './routes/dry-van-freight'
import { Route as DriveWithUsRouteImport } from './routes/drive-with-us'
import { Route as CoverageRouteImport } from './routes/coverage'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'

const RefrigeratedFreightRoute = RefrigeratedFreightRouteImport.update({
            id: '/refrigerated-freight',path: '/refrigerated-freight',getParentRoute: () => rootRouteImport
          })
const DryVanFreightRoute = DryVanFreightRouteImport.update({
            id: '/dry-van-freight',path: '/dry-van-freight',getParentRoute: () => rootRouteImport
          })
const DriveWithUsRoute = DriveWithUsRouteImport.update({
            id: '/drive-with-us',path: '/drive-with-us',getParentRoute: () => rootRouteImport
          })
const CoverageRoute = CoverageRouteImport.update({
            id: '/coverage',path: '/coverage',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,CoverageRoute: CoverageRoute,DriveWithUsRoute: DriveWithUsRoute,DryVanFreightRoute: DryVanFreightRoute,RefrigeratedFreightRoute: RefrigeratedFreightRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)